<template>
  <div id="app">
    <EuiLayout v-if="getterSession.auth">
      <template v-slot:header>
        <EuiSimpleLoader :is-loading="getterIsLoading"/>
        <EuiHeader aria-label="Barre d'entête" >
          <template v-slot:slot-right>
            <div class="flex items-center">
              <span class="mr-4">{{ APP_VERSION }}</span>
              <span class="mr-4">Vous êtes connecté</span>
              <EuiDropdownMenu>
                <EuiList>
                  <EuiListItem :button="true" @click="toLogout">
                    Déconnexion
                  </EuiListItem>
                </EuiList>
                <template v-slot:anchor>
                  <EuiTooltip
                      style="display: inline-block"
                      content="Gestion du profil"
                      placement="top">
                    <template slot="anchor">
                      <EuiButton iconOnly size="large">
                        <EuiIcon name="person"/>
                      </EuiButton>
                    </template>
                  </EuiTooltip>
                </template>
              </EuiDropdownMenu>
            </div>
          </template>
        </EuiHeader>
        <AlertManager/>
        <EuiHeaderMobile @menu="isSidenavOpen = !isSidenavOpen"/>
      </template>
      <template v-slot:sidenav>
        <EuiSidenav
            aria-label="Barre de navigation"
            v-model="isSidenavOpen"
            v-bind:miniVariant.sync="isMiniVariant">
          <EuiSidenavHeader >
            <router-link :to="{ name: 'dashboard' }">
              <div :class="['ef-navbar__logo', { 'mobile': isMiniVariant }]"></div>
            </router-link>
          </EuiSidenavHeader>
          <EuiNavigationMini v-if="isMiniVariant">
            <EuiNavigationSectionMini to="#">
              <template v-slot:header>
                <EuiIcon name="search" size="medium" tabindex="0" />
                Recherche rapide
              </template>
              <EuiNavigationItem tabindex="0" to="/fast-search">
                Correspondance
              </EuiNavigationItem>
            </EuiNavigationSectionMini>
            <EuiNavigationSectionMini  to="#">
              <template v-slot:header>
                <EuiIcon name="more-down" size="medium" tabindex="0" />
                Ajout
              </template>
              <EuiNavigationItem tabindex="0" to="/add/efolia_id">
                efoliaId
              </EuiNavigationItem>
            </EuiNavigationSectionMini>
            <EuiNavigationSectionMini tabindex="0" to="#">
              <template v-slot:header>
                <EuiIcon name="save" size="medium" alt=""/>
                Mise à jour
              </template>
              <EuiNavigationItem tabindex="0" to="/update/firstname-lastname">
                Nom et prénom
              </EuiNavigationItem>
              <EuiNavigationItem tabindex="0" to="/update/login">Login</EuiNavigationItem>
              <EuiNavigationItem tabindex="0" to="/update/email">Email</EuiNavigationItem>
              <EuiNavigationItem tabindex="0" to="/update/gender">Genre</EuiNavigationItem>
              <EuiNavigationItem tabindex="0" to="/update/secret-question">
                Question secrète
              </EuiNavigationItem>
              <EuiNavigationItem tabindex="0" to="/update/demat-status">
                Status de dématérialisation
              </EuiNavigationItem>
            </EuiNavigationSectionMini>
            <EuiNavigationSectionMini to="#">
              <template v-slot:header>
                <EuiIcon name="delete" size="medium"/>
                Suppression
              </template>
              <EuiNavigationItem tabindex="0" to="/delete/duplicates">Doublons</EuiNavigationItem>
              <EuiNavigationItem tabindex="0" to="/delete/rgpd">RGPD</EuiNavigationItem>
            </EuiNavigationSectionMini>
            <EuiNavigationSectionMini to="#">
              <template v-slot:header>
                <EuiIcon name="lock" size="medium"/>
                Déverrouillage
              </template>
              <EuiNavigationItem to="/unlock/attempts">Nombre de tentatives</EuiNavigationItem>
            </EuiNavigationSectionMini>
            <EuiNavigationSectionMini to="#">
              <template v-slot:header>
                <EuiIcon name="download" size="medium" tabindex="0" />
                IP
              </template>
              <EuiNavigationItem tabindex="0" to="/ip/whitelist">
                Whiteliste et ajout IP
              </EuiNavigationItem>
              <EuiNavigationItem tabindex="0" to="/ip/unlock">
                Infos sur IP et déblocage
              </EuiNavigationItem>
            </EuiNavigationSectionMini>
            <EuiNavigationSectionMini >
              <template v-slot:header>
                <EuiIcon name="demat" size="medium" tabindex="0" />
                Mails
              </template>
              <EuiNavigationItem
                  tabindex="0"
                  to="/mails/search">
                Recherche
              </EuiNavigationItem>
              <EuiNavigationItem tabindex="0" to="/mails/invalids">
                Invalides
              </EuiNavigationItem>
            </EuiNavigationSectionMini>
            <EuiNavigationSectionMini to="#">
              <template v-slot:header>
                <EuiIcon name="file" size="medium"/>
                Logs
              </template>
              <EuiNavigationItem
                  tabindex="0"
                  to="/logs/edocperso">
                eDocPerso
              </EuiNavigationItem>
              <EuiNavigationItem
                  tabindex="0"
                  to="/logs/edocparaph">
                eDocParaph
              </EuiNavigationItem>
              <EuiNavigationItem
                  tabindex="0"
                  to="/logs/webdriver">
                WebDriver
              </EuiNavigationItem>
              <EuiNavigationItem
                  tabindex="0"
                  to="/logs/transfert_sftp/asterion">
                Transfert SFTP ASTERION
              </EuiNavigationItem>
              <EuiNavigationItem
                  tabindex="0"
                  to="/logs/transfert_sftp/edcoperso">
                Transfert SFTP eDocPerso
              </EuiNavigationItem>
              <EuiNavigationItem
                  tabindex="0"
                  to="/logs/notifier_manager_edocperso">
                Notification Manager eDocPerso
              </EuiNavigationItem>
              <EuiNavigationItem
                  tabindex="0"
                  to="/logs/notifier_manager_edocsign">
                Notification Manager eDocSign
              </EuiNavigationItem>
              <EuiNavigationItem
                  tabindex="0"
                  to="/logs/parapher">
                Parapher
              </EuiNavigationItem>
            </EuiNavigationSectionMini>
          </EuiNavigationMini>
          <EuiNavigation v-else>
            <EuiNavigationSection>
              <template v-slot:header>
                <EuiIcon name="search" size="medium" tabindex="0" />
                Recherche rapide
              </template>
              <EuiNavigationItem tabindex="0" to="/fast-search">
                Correspondance
              </EuiNavigationItem>
            </EuiNavigationSection>
            <EuiNavigationSection>
              <template v-slot:header>
                <EuiIcon name="more-down" size="medium" tabindex="0" />
                Ajout
              </template>
              <EuiNavigationItem tabindex="0" to="/add/efolia_id">
                efoliaId
              </EuiNavigationItem>
            </EuiNavigationSection>
            <EuiNavigationSection >
              <template v-slot:header>
                <EuiIcon name="save" size="medium" tabindex="0" />
                Mise à jour
              </template>
              <EuiNavigationItem tabindex="0" to="/update/firstname-lastname">
                Nom et prénom
              </EuiNavigationItem>
              <EuiNavigationItem tabindex="0" to="/update/login">Login</EuiNavigationItem>
              <EuiNavigationItem tabindex="0" to="/update/email">Email</EuiNavigationItem>
              <EuiNavigationItem tabindex="0" to="/update/gender">Genre</EuiNavigationItem>
              <EuiNavigationItem tabindex="0" to="/update/secret-question">
                Question secrète
              </EuiNavigationItem>
              <EuiNavigationItem tabindex="0" to="/update/demat-status">
                Status de dématérialisation
              </EuiNavigationItem>
            </EuiNavigationSection>
            <EuiNavigationSection>
              <template v-slot:header>
                <EuiIcon name="delete" size="medium"/>
                Suppression
              </template>
              <EuiNavigationItem tabindex="0" to="/delete/duplicates">Doublons</EuiNavigationItem>
              <EuiNavigationItem tabindex="0" to="/delete/rgpd">RGPD</EuiNavigationItem>
            </EuiNavigationSection>
            <EuiNavigationSection>
              <template v-slot:header>
                <EuiIcon name="lock" size="medium"/>
                Déverrouillage
              </template>
              <EuiNavigationItem
                  tabindex="0"
                  to="/unlock/attempts">
                Nombre de tentatives
              </EuiNavigationItem>
            </EuiNavigationSection>
            <EuiNavigationSection v-if="HTTP_CONFIG.backOfficeVersion !== 'V2'">
              <template v-slot:header>
                <EuiIcon name="download" size="medium" tabindex="0" />
                IP
              </template>
              <EuiNavigationItem tabindex="0" to="/ip/whitelist">
                Whiteliste et ajout IP
              </EuiNavigationItem>
              <EuiNavigationItem tabindex="0" to="/ip/unlock">
                Infos sur IP et déblocage
              </EuiNavigationItem>
            </EuiNavigationSection>
            <EuiNavigationSection v-if="HTTP_CONFIG.backOfficeVersion !== 'V2'">
              <template v-slot:header>
                <EuiIcon name="demat" size="medium" tabindex="0" />
                Mails
              </template>
              <EuiNavigationItem
                  tabindex="0"
                  to="/mails/search">
                Recherche
              </EuiNavigationItem>
              <EuiNavigationItem tabindex="0" to="/mails/invalids">
                Invalides
              </EuiNavigationItem>
            </EuiNavigationSection>
            <EuiNavigationSection v-if="HTTP_CONFIG.backOfficeVersion !== 'V2'">
              <template v-slot:header>
                <EuiIcon name="file" size="medium"/>
                Logs
              </template>
              <EuiNavigationItem
                  tabindex="0"
                  to="/logs/edocperso">
                eDocPerso
              </EuiNavigationItem>
              <EuiNavigationItem
                  tabindex="0"
                  to="/logs/edocparaph">
                eDocParaph
              </EuiNavigationItem>
              <EuiNavigationItem
                  tabindex="0"
                  to="/logs/webdriver">
                WebDriver
              </EuiNavigationItem>
              <EuiNavigationItem
                  tabindex="0"
                  to="/logs/transfert_sftp/asterion">
                Transfert SFTP Asterion
              </EuiNavigationItem>
              <EuiNavigationItem
                  tabindex="0"
                  to="/logs/transfert_sftp/edocperso">
                Transfert SFTP eDocPerso
              </EuiNavigationItem>
              <EuiNavigationItem
                  tabindex="0"
                  to="/logs/notifier_manager_edocperso">
                Notification Manager eDocPerso
              </EuiNavigationItem>
              <EuiNavigationItem
                  tabindex="0"
                  to="/logs/notifier_manager_edocsign">
                Notification Manager eDocSign
              </EuiNavigationItem>
              <EuiNavigationItem
                  tabindex="0"
                  to="/logs/parapher">
                Parapher
              </EuiNavigationItem>
            </EuiNavigationSection>
          </EuiNavigation>
        </EuiSidenav>
      </template>

      <router-view class="mt-3 mb-1"/>
    </EuiLayout>
    <template v-else>
      <router-view/>
    </template>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';
import AlertManager from './components/layout/AlertManager.vue';
import { HTTP_CONFIG } from './http';


export default {
  name: 'App',
  components: { AlertManager },
  data() {
    return {
      isSidenavOpen: true,
      isMobileView: false,
      isMiniVariant: false,
      HTTP_CONFIG,
    };
  },
  computed: {
    ...mapGetters({
      getterSession: 'auth/session',
      getterIsLoading: 'application/isLoading',
    }),
    APP_VERSION() {
      return `v${process.env.VUE_APP_VERSION}`;
    },
  },
  mounted() {
    if (this.getterSession.token) {
      this.storeCheckToken({ sessionId: this.getterSession.token, login: 'maxdd' }).catch(() => {
        this.storeResetToken();
        this.$router.push({ name: 'login' });
      });
    }
  },
  watch: {
    isMiniVariant(value) {
      this.storeSetMiniVariant(value);
    },
  },
  methods: {
    ...mapActions({
      storeLogout: 'auth/logout',
      storeCheckToken: 'auth/checkToken',
      storeResetToken: 'auth/resetToken',
      storeSetMiniVariant: 'application/setIsMiniVariant',
      storeSetConfig: 'application/setConfig',
    }),
    toLogout() {
      this.storeLogout({ sessionId: this.getterSession.token })
        .then(() => {
          this.$router.push({ name: 'login' });
        });
    },
  },
};
</script>
